<template>
  <div>
    <div class="card">
      <h5 class="card-header">User Export</h5>
      <div class="card-body">
        <p>
          Export all users and organizations in the platform to an Excel file. The export includes Organization Display Name, Organization Legal Name, Full
          Name, First Name, Last Name, and Email Address. Only active organizations and users (not deleted) with "enabled" status are included.
        </p>
        <button type="button" class="btn btn-primary" @click="exportUsers" :disabled="isExporting">
          <fa v-if="isExporting" icon="circle-notch" spin />
          <fa v-if="!isExporting" icon="file-excel" />
          <span class="ml-2">Export Users</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isExporting: false,
    };
  },
  methods: {
    exportUsers() {
      this.isExporting = true;

      this.$axios
        .post("/v1/admin/users/export")
        .then(res => {
          const link = document.createElement("a");
          link.target = "_blank";
          link.rel = "noopener noreferrer";
          link.href = res.data.url;
          link.click();
          link.remove();
        })
        .catch(error => {
          console.error("Export failed", error);
          alert(`Export failed: ${error.response?.data?.detail || error.message}`);
        })
        .finally(() => {
          this.isExporting = false;
        });
    },
  },
};
</script>
